import moment from 'moment';

// moment.utc keeps the render in UTC. NB: do NOT use the shared
// Utils.formatDateUtc (immersive_utils.tsx:507) - it formats in local time and
// only labels it UTC, which is a display bug.
export const formatUtc = (value?: string): string =>
  value ? `${moment.utc(value).format('DD MMM YYYY - HH:mm')} UTC` : '-';
